import * as Types from './types';
import { actionTypes } from './constants';
import { IPlayerAcceptedTerm } from '../types';

export const updateTermsAndConditionsHistory = (data: IPlayerAcceptedTerm[]): Types.IUpdateTermsAndConditionsHistoryAction => ({
    type: actionTypes.TERMS_AND_CONDITIONS_HISTORY_DATA_UPDATE,
    payload: data
});

export const toggleIsLoading = (isLoading: boolean): Types.IToggleIsLoadingAction => ({
    type: actionTypes.TERMS_AND_CONDITIONS_HISTORY_IS_LOADING_TOGGLE,
    payload: isLoading
});
